!function (e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
}(exports, function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 7);
}([function (e, t, r) {
  e.exports = r(9);
}, function (e, t) {
  e.exports = require("lodash");
}, function (e, t) {
  e.exports = require("react-notify-toast");
}, function (e, t) {
  e.exports = require("redux");
}, function (e, t) {
  e.exports = require("redux-thunk");
}, function (e, t) {
  e.exports = require("redux-logger");
}, function (e, t) {
  e.exports = require("react-sortable-hoc");
}, function (e, t, r) {
  r(8), e.exports = r(10);
}, function (e, t) {
  e.exports = require("babel-polyfill");
}, function (e, t) {
  e.exports = require("regenerator-runtime");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(3),
      o = r(4),
      a = r.n(o),
      c = r(5),
      s = r.n(c);

  function u(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function i(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {},
          n = Object.keys(r);
      "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
        return Object.getOwnPropertyDescriptor(r, e).enumerable;
      }))), n.forEach(function (t) {
        u(e, t, r[t]);
      });
    }

    return e;
  }

  function d(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  var p = r(0),
      l = r.n(p);

  function f(e, t, r, n, o, a, c) {
    try {
      var s = e[a](c),
          u = s.value;
    } catch (e) {
      return void r(e);
    }

    s.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function y(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var a = e.apply(t, r);

        function c(e) {
          f(a, n, o, c, s, "next", e);
        }

        function s(e) {
          f(a, n, o, c, s, "throw", e);
        }

        c(void 0);
      });
    };
  }

  function m(e, t, r, n, o) {
    return function () {
      var a = y(l.a.mark(function a(c, s) {
        var u, i, d, p, f, y, m, h, C, P;
        return l.a.wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (!(u = new URLSearchParams(window.location.search)).has("token")) {
                  a.next = 5;
                  break;
                }

                return localStorage.setItem("uta.auth", u.get("token")), a.next = 5, c(K(u.get("token")));

              case 5:
                return i = s().user.user, d = s().deployOptions.apiServerUrl, p = "GET" !== r, f = o && o.map(function (e) {
                  return "".concat(Object.keys(e)[0], "=").concat(Object.values(e)[0]);
                }).join("&"), y = o ? t + "?" + f : t, m = "".concat(d).concat(y), h = p ? JSON.stringify(n) : void 0, !(C = i.auth) && u.has("token") && (C = u.get("token")), P = {
                  Authorization: "JWT " + C,
                  Accept: "application/json",
                  "Content-Type": "application/json"
                }, c({
                  type: e,
                  url: m,
                  payload: n,
                  query: o,
                  isLoading: !0
                }), a.abrupt("return", window.fetch(m, {
                  method: r,
                  body: h,
                  headers: new window.Headers(P),
                  mode: "cors",
                  cache: "default",
                  redirect: "follow"
                }).then(function (t) {
                  return 401 !== t.status || window.location.pathname.includes("login") || (window.location = "/login"), t.json().then(function (r) {
                    return 401 !== t.status || window.location.pathname.includes("login") || (c(M()), window.location = "/login"), c({
                      type: e,
                      body: r,
                      payload: n,
                      query: o,
                      url: t.url,
                      status: t.status,
                      headers: t.headers,
                      ok: t.ok,
                      isLoading: !1
                    });
                  }, function (r) {
                    return c({
                      type: e,
                      error: r,
                      payload: n,
                      query: o,
                      url: t.url,
                      status: t.status,
                      headers: t.headers,
                      parseError: !0,
                      isLoading: !1
                    });
                  });
                }).catch(function (t) {
                  return c({
                    type: e,
                    error: t,
                    url: m,
                    payload: n,
                    query: o,
                    failed: !0,
                    isLoading: !1
                  });
                }));

              case 17:
              case "end":
                return a.stop();
            }
          }
        }, a, this);
      }));
      return function (e, t) {
        return a.apply(this, arguments);
      };
    }();
  }

  var h = function () {
    function e(t) {
      var r = t.path,
          n = t.query;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.path = r, this.query = n;
    }

    return function (e, t, r) {
      t && d(e.prototype, t), r && d(e, r);
    }(e, [{
      key: "list",
      value: function value(e, t) {
        return t = t || this.query, m(e, this.path, "GET", null, t);
      }
    }, {
      key: "create",
      value: function value(e, t, r) {
        return r = r || this.query, m(e, this.path, "POST", t, r);
      }
    }, {
      key: "update",
      value: function value(e, t, r, n) {
        return m(e, "".concat(this.path, "/").concat(t), "PATCH", r, n = n || this.query);
      }
    }, {
      key: "get",
      value: function value(e, t, r) {
        return m(e, "".concat(this.path, "/").concat(t), "GET", null, r = r || this.query);
      }
    }, {
      key: "delete",
      value: function value(e, t) {
        return m(e, "".concat(this.path, "/").concat(t), "DELETE");
      }
    }]), e;
  }(),
      C = new h({
    path: "/user",
    query: [{
      $populate: "deskIds"
    }, {
      $populate: "personId"
    }]
  }),
      P = new h({
    path: "/archive"
  });

  P.search = function (e, t) {
    return m(e, "/archive", "GET", null, t = t || (void 0).query);
  };

  var _ = new h({
    path: "/person",
    query: [{
      $populate: "contacts"
    }, {
      $populate: "addresses"
    }, {
      $populate: "companyId"
    }]
  });

  _.search = function (e, t) {
    return m(e, "/person", "GET", null, t = t || (void 0).query);
  }, _.searchOutlook = function (e, t) {
    return m(e, "/o365", "GET", null, t = t || (void 0).query);
  }, _.merge = function (e, t) {
    return m(e, "/merge", "POST", t, []);
  }, _.uploadContacts = function (e, t) {
    return m(e, "/uploadContacts", "POST", t, []);
  };
  var T = new h({
    path: "/contact"
  }),
      E = new h({
    path: "/company"
  }),
      v = new h({
    path: "/address"
  }),
      g = new h({
    path: "/change"
  }),
      O = new h({
    path: "/relationship"
  }),
      R = new h({
    path: "/call_todo",
    query: [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }]
  }),
      S = new h({
    path: "/status"
  }),
      j = new h({
    path: "/project"
  }),
      b = new h({
    path: "/project_note"
  }),
      A = new h({
    path: "/project_role"
  }),
      I = new h({
    path: "/desk"
  }),
      L = new h({
    path: "/project_casting"
  }),
      F = new h({
    path: "/project_submission"
  }),
      w = new h({
    path: "/project_script"
  }),
      N = new h({
    path: "/project_tracking"
  }),
      k = new h({
    path: "/filter"
  }),
      D = r(1),
      $ = r(6),
      x = {
    redirect: "REDIRECT",
    invalidate: "INVALIDATE",
    loadUser: "LOAD_USER",
    setUser: "SET_USER",
    setDesk: "SET_DESK",
    setAuth: "SET_AUTH",
    statusEdit: "EDIT_STATUES",
    status: "LIST_STATUES",
    updateDeskSettings: "UPDATE_DESK_SETTINGS",
    updateStatus: "UPDATE_STATUS",
    moveStatus: "MOVE_STATUS"
  };

  function J(e, t, r, n) {
    var o = "".concat(n).concat("/auth/azure");
    r && (o += "?redirect=", o += r), window.location = o;
  }

  function M() {
    return {
      type: x.invalidate
    };
  }

  function U(e) {
    return C.get(x.loadUser, e);
  }

  function H(e) {
    return {
      type: x.setDesk,
      desk: e
    };
  }

  function G(e, t, r) {
    var n = i({}, e.settings, u({}, t, r));
    return I.update(x.updateDeskSettings, e._id, i({}, e, {
      settings: n
    }));
  }

  function q(e, t, r) {
    return {
      type: x.updateStatus,
      index: e,
      field: t,
      value: r
    };
  }

  function B(e) {
    return S.create(x.statusEdit, {
      statuses: e
    });
  }

  function V(e, t) {
    return {
      type: x.moveStatus,
      oldIndex: e,
      newIndex: t
    };
  }

  function Y(e) {
    return S.list(x.status, [{
      deskId: e
    }]);
  }

  function K(e) {
    return {
      type: x.setAuth,
      auth: e
    };
  }

  var W = {
    user: null,
    desk: null,
    status: [],
    isLoading: !1
  };
  var z = {
    listArchive: "LIST_ARCHIVE",
    searchArchive: "SEARCH_ARCHIVE",
    updateArchive: "UPDATE_ARCHIVE",
    clearArchive: "CLEAR_ARCHIVE"
  };

  function X(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        var n;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                (n = [{
                  $limit: 150
                }]).push({
                  $search: "name|company|contact:".concat(e)
                }), r(P.search(z.searchArchive, n));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Q(e) {
    return m(z.listArchive, "/archive", "GET", null, e);
  }

  function Z(e) {
    return m(z.updateArchive, "/archive/" + e._id, "PUT", e, null);
  }

  function ee() {
    return {
      type: z.clearArchive
    };
  }

  var te = {
    archives: [],
    archiveCount: 0,
    archiveFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    }
  };
  var re = {
    apiServerUrl: ""
  };

  function ne(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "00",
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
    return "".concat(t).concat(e).slice(-r);
  }

  function oe(e) {
    var t = e.getHours() >= 12 ? "pm" : "am";
    return "".concat(e.getHours() % 12 > 0 ? e.getHours() % 12 : 12, ":").concat(ne(e.getMinutes())).concat(t);
  }

  var ae = {
    resetForm: "RESET_FORM",
    clearPerson: "CLEAR_PERSON",
    clearPersonSearch: "CLEAR_PERSON_SEARCH",
    clearContactSearch: "CLEAR_CONTACT_SEARCH",
    updateForm: "UPDATE_FORM",
    searchCompany: "SEARCH_COMPANY",
    searchPerson: "SEARCH_PERSON",
    searchPrivate: "SEARCH_PRIVATE",
    searchOutlook: "SEARCH_OUTLOOK",
    searchResults: "SEARCH_RESULTS",
    searchContact: "SEARCH_CONTACT",
    selectPerson: "SELECT_PERSON",
    selectType: "SELECT_CONTACT_TYPE",
    selectContact: "SELECT_CONTACT",
    editCallTodo: "EDIT_CALL_TODO",
    createPerson: "CREATE_ADHOC_PERSON",
    createCompany: "CREATE_ADHOC_COMPANY",
    createContact: "CREATE_ADHOC_CONTACT",
    createAddress: "CREATE_ADHOC_ADDRESS",
    updatePerson: "UPDATE_PERSON",
    showForm: "SHOW_FORM"
  },
      ce = {
    status: "I",
    name: "",
    type: "Home Phone",
    info: "",
    notes: "",
    externalCompany: "",
    date: null,
    time: "12:00",
    edited: !1,
    showForm: !1,
    person: {
      isLoading: !1,
      results: null,
      selected: null
    },
    outlook: {
      isLoading: !1,
      results: null
    },
    contact: {
      results: null,
      selected: null
    },
    editCallTodo: null
  };

  function se(e, t) {
    return function (r, n) {
      if (r({
        type: ae.updateForm,
        field: e,
        value: t
      }), "name" === e && (n().callForm.info || r(ie())), "info" === e) {
        var o = n().callForm.person.selected;
        o && r(ye(t, o.contacts));
      }
    };
  }

  function ue() {
    return {
      type: ae.showForm
    };
  }

  function ie() {
    return {
      type: ae.clearPerson
    };
  }

  function de() {
    return {
      type: ae.clearPersonSearch
    };
  }

  function pe() {
    return {
      type: ae.clearContactSearch
    };
  }

  function le() {
    return {
      type: ae.resetForm
    };
  }

  function fe(e, t) {
    return function () {
      var r = y(l.a.mark(function r(n) {
        var o, a, c;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return o = [{
                  prefix: e
                }, {
                  desk: t
                }], [{
                  $filter: "name:".concat(e)
                }, {
                  deskId: t
                }], (a = []).push({
                  $search: "".concat(e)
                }, {
                  $emppriority: !0
                }), r.next = 6, n(m(ae.searchPerson, "/person", "GET", null, a));

              case 6:
                c = r.sent.body.data, n({
                  type: ae.searchResults,
                  data: [].concat(c)
                }), n(_.searchOutlook(ae.searchOutlook, o));

              case 9:
              case "end":
                return r.stop();
            }
          }
        }, r, this);
      }));
      return function (e) {
        return r.apply(this, arguments);
      };
    }();
  }

  function ye(e, t) {
    var r = e ? t.filter(function (t) {
      return t && t.contact && t.contact.includes(e);
    }) : t;
    return {
      type: ae.searchContact,
      results: r
    };
  }

  function me(e) {
    return {
      type: ae.selectPerson,
      person: e
    };
  }

  function he(e) {
    return {
      type: ae.selectType,
      contactType: e
    };
  }

  function Ce(e) {
    return {
      type: ae.selectContact,
      contact: e
    };
  }

  function Pe(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        var n, o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r({
                  type: ae.editCallTodo,
                  callTodo: e
                }), t.next = 3, r(_.get(ae.selectPerson, e.recipientId._id));

              case 3:
                r(Ce(e.contactId)), r(se("notes", e.description)), r(se("status", e.status)), n = new Date(e.occurrence_date), o = oe(n), r(se("date", n)), r(se("time", o));

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function _e(e) {
    return _.create(ae.createPerson, e);
  }

  function Te(e) {
    return E.create(ae.createCompany, e);
  }

  function Ee(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(_.update(ae.updatePerson, e._id, e, [{
                  $excludes: "profile_pic"
                }]));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function ve(e, t) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(v.create(ae.createAddress, e));

              case 2:
                return o = t.sent.body, t.abrupt("return", {
                  body: o
                });

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function ge(e, t) {
    return function () {
      var r = y(l.a.mark(function r(n, o) {
        var a, c;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return r.next = 2, n(T.create(ae.createContact, e));

              case 2:
                return a = r.sent.body, (c = i({}, t, {
                  contacts: t.contacts.concat([a._id])
                })).companyId && !c.companyId._id && delete c.companyId, r.next = 7, n(_.update(ae.updatePerson, t._id, c, [{
                  $excludes: "profile_pic"
                }]));

              case 7:
                return r.abrupt("return", {
                  body: a
                });

              case 8:
              case "end":
                return r.stop();
            }
          }
        }, r, this);
      }));
      return function (e, t) {
        return r.apply(this, arguments);
      };
    }();
  }

  var Oe = 500,
      Re = {
    list: "LIST_CALL_TODO",
    create: "CREATE_CALL_TODO",
    update: "UPDATE_CALL_TODO",
    delete: "DELETE_CALL_TODO",
    listByPerson: "LIST_CALL_TODO_BY_PERSON",
    editStatus: "SET_EDIT_STATUS",
    preview: "PREVIEW_CALL",
    loadPerson: "LOAD_PREVIEW_PERSON",
    loadHistory: "LOAD_HISTORY"
  };

  function Se(e) {
    var t = [{
      fieldId: e
    }, {
      $populate: "userId"
    }, {
      "$sort[timestamp]": -1
    }];
    return g.list(Re.loadHistory, t);
  }

  function je(e) {
    var t = [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      $populate: "companyId"
    }, {
      $limit: Oe
    }, {
      "$sort[occurrence_date]": -1
    }, {
      $limit: 500
    }];
    return e && Object.keys(e).forEach(function (r) {
      if (e[r]) {
        var n;

        switch (r) {
          case "startDate":
            n = {
              "occurrence_date[$gte]": e[r]
            };
            break;

          case "endDate":
            n = {
              "occurrence_date[$lte]": e[r]
            };
            break;

          case "query":
            n = {
              $search: "recipientName|companyName|contactInfo:".concat(e[r])
            };
            break;

          case "page":
            n = {
              $skip: 50 * (e[r] - 1)
            };
            break;

          case "desk":
            n = {
              deskId: e[r]
            };
            break;

          case "status":
            n = {
              status: e[r]
            };
            break;

          default:
            n = u({}, r, e[r]);
        }

        t.push(n);
      }
    }), R.list(Re.list, t);
  }

  function be(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(R.create(Re.create, e));

              case 2:
                r(je({
                  desk: e.deskId
                }));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Ae(e, t) {
    return function () {
      var r = y(l.a.mark(function r(n) {
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return r.next = 2, n(R.update(Re.update, e, t));

              case 2:
              case "end":
                return r.stop();
            }
          }
        }, r, this);
      }));
      return function (e) {
        return r.apply(this, arguments);
      };
    }();
  }

  function Ie(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(R.delete(Re.delete, e));

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Le(e) {
    return {
      type: Re.preview,
      call: e
    };
  }

  var Fe = {
    calls: {
      callTodos: [],
      status: [],
      isLoading: !1,
      total: null,
      limit: 500,
      skip: 0
    },
    preview: {
      call: null,
      person: null,
      history: [],
      isLoading: !1
    }
  };
  var we = "JULIUS_PROJECTS",
      Ne = {
    loadFilters: "FILTERS_LOAD_FILTERS",
    createFilter: "FILTERS_CREATE_FILTER",
    updateFilter: "FILTERS_UPDATE_FILTER",
    setCurrentFilter: "FILTERS_SET_CURRENT_FILTER"
  };

  function ke(e) {
    var t = [{
      deskId: e
    }, {
      service: we
    }];
    return k.list(Ne.loadFilters, t);
  }

  function De(e) {
    return e.service = we, k.create(Ne.createFilter, e, []);
  }

  function $e(e, t) {
    return k.update(Ne.updateFilter, e, t);
  }

  function xe(e) {
    return {
      type: Ne.setCurrentFilter,
      newFilterId: e
    };
  }

  var Je = {
    currentFilterIndex: 0,
    filters: []
  };
  var Me = [["1", 1], ["2", 2], ["3", 3], ["4", 4], ["5", 5], ["6", 6], ["7", 7], ["8", 8], ["9", 9], [" 10", 10], [" 11", 11], [" 12", 12], [" 13", 13], [" 14", 14], [" 15", 15], [" 16", 16], [" 17", 17], [" 18", 18], [" 19", 19], [" 20", 20]],
      Ue = {
    createProjectCasting: "PROJECT_CASTING_CREATE_PROJECT_CASTING",
    loadProjectCasting: "PROJECT_CASTINGS_LOAD_PROJECT_CASTING",
    loadProjectCastings: "PROJECT_CASTINGS_LOAD_PROJECT_CASTINGS",
    removeProjectCasting: "PROJECT_CASTING_REMOVE_PROJECT_CASTING",
    setProjectCastingForm: "PROJECT_CASTING_SET_PROJECT_CASTING_FORM",
    updateProjectCasting: "PROJECT_CASTING_UPDATE_PROJECT_CASTING",
    updateProjectCastingForm: "PROJECT_CASTING_UPDATE_PROJECT_CASTING_FORM"
  };

  function He(e) {
    return m(Ue.loadProjectCastings, "/project_casting", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function Ge(e) {
    return L.get(Ue.loadProjectCasting, e, [{
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function qe(e) {
    return L.create(Ue.createProjectCasting, e, []);
  }

  function Be(e) {
    return L.delete(Ue.removeProjectCasting, e);
  }

  function Ve(e, t) {
    return L.update(Ue.updateProjectCasting, e, t);
  }

  function Ye(e, t) {
    return function (r) {
      r({
        type: Ue.updateProjectCastingForm,
        field: e,
        value: t
      });
    };
  }

  function Ke(e) {
    var t = Me.find(function (t) {
      return t[1] === e.priority;
    });
    return {
      type: Ue.setProjectCastingForm,
      projectCastingForm: {
        _id: e._id,
        _person: e.personId,
        ageMax: e.ageMax,
        ageMin: e.ageMin,
        description: e.description,
        gender: e.gender,
        notes: e.notes,
        name: e.name,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        },
        priority: t && t[0],
        status: e.status,
        type: e.type,
        isClient: e.isClient
      }
    };
  }

  var We = {
    projectCasting: null,
    projectCastings: [],
    isLoading: !1,
    projectCastingForm: {
      _id: "",
      ageMax: "",
      ageMin: "",
      name: "",
      description: "",
      gender: "",
      notes: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      },
      priority: "",
      status: "",
      type: "",
      isClient: ""
    }
  };
  var ze = {
    createProjectNote: "PROJECT_NOTES_CREATE_PROJECT_NOTES",
    loadProjectNote: "PROJECT_NOTES_LOAD_PROJECT_NOTE",
    loadProjectNotes: "PROJECT_NOTES_LOAD_PROJECT_NOTES",
    removeProjectNote: "PROJECT_NOTES_REMOVE_PROJECT_NOTES",
    setProjectNoteForm: "PROJECT_NOTES_SET_PROJECT_NOTES_FORM",
    updateProjectNote: "PROJECT_NOTES_UPDATE_PROJECT_NOTES",
    updateProjectNoteForm: "PROJECT_NOTES_UPDATE_PROJECT_NOTES_FORM"
  };

  function Xe(e) {
    return m(ze.loadProjectNotes, "/project_note", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }, {
      "$sort[created]": -1
    }]);
  }

  function Qe(e) {
    return b.get(ze.loadProjectNote, e, [{
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function Ze(e) {
    return b.create(ze.createProjectNote, e, []);
  }

  function et(e) {
    return b.delete(ze.removeProjectNote, e);
  }

  function tt(e, t) {
    return b.update(ze.updateProjectNote, e, t);
  }

  function rt(e, t) {
    return function (r) {
      r({
        type: ze.updateProjectNoteForm,
        field: e,
        value: t
      });
    };
  }

  function nt(e) {
    return {
      type: ze.setProjectNoteForm,
      projectNoteForm: {
        _id: e._id,
        _person: e.personId,
        note: e.note,
        type: e.type,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        }
      }
    };
  }

  var ot = {
    projectNote: null,
    projectNotes: [],
    isLoading: !1,
    projectNoteForm: {
      _id: "",
      note: "",
      type: ""
    }
  };
  var at = {
    createProjectTracking: "ROJECT_TRACKING_CREATE_ROJECT_TRACKING",
    removeProjectTracking: "ROJECT_TRACKING_REMOVE_ROJECT_TRACKING",
    setProjectTrackingForm: "ROJECT_TRACKING_SET_ROJECT_TRACKING_FORM",
    updateProjectTracking: "ROJECT_TRACKING_UPDATE_ROJECT_TRACKING",
    updateProjectTrackingForm: "ROJECT_TRACKING_UPDATE_ROJECT_TRACKING_FORM"
  };

  function ct(e) {
    return N.create(at.createProjectTracking, e, []);
  }

  function st(e) {
    return N.delete(at.removeProjectTracking, e);
  }

  function ut(e, t) {
    return N.update(at.updateProjectTracking, e, t);
  }

  function it(e, t) {
    return function (r) {
      r({
        type: at.updateProjectTrackingForm,
        field: e,
        value: t
      });
    };
  }

  function dt(e) {
    return {
      type: at.setProjectTrackingForm,
      projectTrackingForm: {
        _id: e._id,
        _person: e.personId,
        description: e.description,
        jobName: e.jobName,
        listType: e.listType,
        note: e.note,
        person: {
          isLoading: !1,
          results: null,
          selected: null
        },
        updated: e.updated
      }
    };
  }

  var pt = {
    projectTracking: null,
    projectTrackings: [],
    isLoading: !1,
    projectTrackingForm: {
      _id: "",
      description: "",
      jobName: "",
      listType: "",
      note: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    }
  };

  function lt(e, t) {
    return t.map(function (t) {
      var r,
          n,
          o = t._id,
          a = t.personId1,
          c = t.personId2,
          s = t.type;
      return e === a._id ? (r = i({}, a, {
        role: "Talent"
      }), n = i({}, c, {
        role: "Talent"
      })) : (r = i({}, c, {
        role: s
      }), n = i({}, a, {
        role: s
      })), {
        _id: o,
        type: n.role,
        person: r,
        party: n
      };
    });
  }

  function ft(e) {
    var t,
        r,
        n = e._id,
        o = e.person,
        a = e.party,
        c = function (e) {
      return e ? e.replace(/ /g, "") : "";
    }(e.type);

    return yt.includes(c) ? (t = a, r = o) : (t = o, r = a, c = function (e) {
      return e.split("To").reverse().join("To");
    }(c)), {
      _id: n,
      personId1: t,
      personId2: r,
      type: c
    };
  }

  var yt = ["ResponsibleAgent", "Agent", "Assistant", "Manager", "Attorney", "BusinessPartner", "PersonalManager", "Agency", "Studio", "ProductionCompany", "BusinessAffairs", "Negotiator", "CastingDirector", "Director", "Producer", "ExecProducer", "Publicist", "Network", "UTAPackage", "UTAElement", "Creator", "Buyer"];
  var mt = {
    searchPerson: "SEARCH_PERSON",
    searchCompany: "SEARCH_COMPANY",
    loadPerson: "PROFILE_LOAD_PERSON",
    updatePerson: "PROFILE_UPDATE_PERSON",
    updateContact: "PROFILE_UPDATE_CONTACT",
    updateAddress: "PROFILE_UPDATE_ADDRESS",
    updateRelation: "PROFILE_UPDATE_RELATIONSHIP",
    addContact: "PROFILE_ADD_CONTACT",
    addCompany: "PROFILE_ADD_COMPANY",
    addAddress: "PROFILE_ADD_ADDRESS",
    addRelation: "PROFILE_ADD_RELATION",
    removeContact: "PROFILE_REMOVE_CONTACT",
    removeAddress: "PROFILE_REMOVE_ADDRESS",
    removeRelation: "PROFILE_REMOVE_RELATION",
    listHistory: "PROFILE_LIST_HISTORY",
    listCalls: "PROFILE_LIST_CALLS",
    loadRelation: "PROFILE_LOAD_RELATIONSHIPS",
    listByPerson1: "PROFILE_LIST_RELATION_1",
    listByPerson2: "PROFILE_LIST_RELATION_2"
  };

  function ht(e, t) {
    var r = "name:".concat(e, "&"),
        n = [{
      $search: r += t ? "type=" + t : "type[$ne]=Ad Hoc"
    }];
    return m(mt.searchPerson, "/person", "GET", null, n);
  }

  function Ct(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return m(mt.searchCompany, "/company", "GET", null, t);
  }

  function Pt(e) {
    return _.get(mt.loadPerson, e);
  }

  function _t(e, t) {
    return _.update(mt.updatePerson, e, t);
  }

  function Tt(e, t) {
    return T.update(mt.updateContact, e, t);
  }

  function Et(e, t) {
    return v.update(mt.updateAddress, e, t);
  }

  function vt(e, t) {
    return function (r, n) {
      var o = ft(i({}, n().profile.relationships.find(function (t) {
        return t._id === e;
      }), t));
      r(O.update(mt.updateRelation, e, o));
    };
  }

  function gt(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o, a, c;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = n().profile.person, t.next = 3, r(T.create(mt.addContact, e));

              case 3:
                return a = t.sent.body, c = i({}, o, {
                  contacts: o.contacts.concat([a._id])
                }), t.next = 7, r(_t(o._id, c));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Ot(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o, a, c;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = n().profile.person, t.next = 3, r(v.create(mt.addAddress, e));

              case 3:
                return a = t.sent.body, c = i({}, o, {
                  addresses: o.addresses.concat([a._id])
                }), t.next = 7, r(_t(o._id, c));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Rt(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                n().profile.person, o = ft(e), r(O.create(mt.addRelation, o));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function St(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = n().profile.person, t.next = 3, r(T.delete(mt.removeContact, e));

              case 3:
                return o = i({}, o, {
                  contacts: o.contacts.filter(function (t) {
                    return t._id !== e;
                  })
                }), t.next = 6, r(_t(o._id, o));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function jt(e) {
    return function () {
      var t = y(l.a.mark(function t(r, n) {
        var o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = n().profile.person, t.next = 3, r(v.delete(mt.removeAddress, e));

              case 3:
                return o = i({}, o, {
                  addresses: o.addresses.filter(function (t) {
                    return t._id !== e;
                  })
                }), t.next = 6, r(_t(o._id, o));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }();
  }

  function bt(e) {
    return O.delete(mt.removeRelation, e);
  }

  function At(e) {
    var t = [{
      fieldId: e
    }, {
      $populate: "userId"
    }, {
      "$sort[timestamp]": -1
    }];
    return g.list(mt.listHistory, t);
  }

  function It(e) {
    var t = [{
      $limit: 20
    }, {
      recipientId: e
    }, {
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      "$sort[timestamp]": -1
    }];
    return R.list(mt.listCalls, t);
  }

  function Lt(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        var n, o, a;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(Ft(e));

              case 2:
                return n = t.sent.body.data, t.next = 5, r(wt(e));

              case 5:
                o = t.sent.body.data, a = lt(e, n.concat(o)), r({
                  type: mt.loadRelation,
                  relationships: a
                });

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Ft(e) {
    var t = [{
      personId1: e
    }, {
      $populate: "personId1"
    }, {
      $populate: "personId2"
    }];
    return O.list(mt.listByPerson1, t);
  }

  function wt(e) {
    var t = [{
      personId2: e
    }, {
      $populate: "personId1"
    }, {
      $populate: "personId2"
    }];
    return O.list(mt.listByPerson2, t);
  }

  var Nt = {
    person: null,
    history: null,
    calls: null,
    relationships: null,
    isLoading: !1
  };
  var kt = r(2),
      Dt = {
    listPeople: "LIST_PEOPLE",
    listCompany: "LIST_COMPANY",
    createCompany: "CREATE_COMPANY",
    createPerson: "CREATE_PERSON",
    mergePerson: "MERGE_PERSON",
    editCompany: "EDIT_COMPANY",
    deletePeople: "DELETE_PEOPLE",
    deleteCompany: "DELETE_COMPANY",
    searchPerson: "SEARCH_PERSON",
    uploadContacts: "UPLOAD_CONTACTS"
  };

  function $t(e, t) {
    return function () {
      var r = y(l.a.mark(function r(n) {
        var o;
        return l.a.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                (o = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  $excludes: "profile_pic"
                }, {
                  offset: 20 * t
                }]).push({
                  $search: "".concat(e)
                }), n(_.search(Dt.searchPerson, o));

              case 3:
              case "end":
                return r.stop();
            }
          }
        }, r, this);
      }));
      return function (e) {
        return r.apply(this, arguments);
      };
    }();
  }

  function xt(e) {
    return m(Dt.listPeople, "/person", "GET", null, e);
  }

  function Jt(e) {
    return m(Dt.listCompany, "/company", "GET", null, e);
  }

  function Mt(e) {
    return E.create(Dt.createCompany, e);
  }

  function Ut(e) {
    return _.merge(Dt.mergePerson, e);
  }

  function Ht(e) {
    return _.create(Dt.createPerson, e);
  }

  function Gt(e) {
    return E.update(Dt.editCompany, e._id, e);
  }

  function qt(e) {
    return _.delete(Dt.deletePeople, e);
  }

  function Bt(e) {
    return E.delete(Dt.deleteCompany, e);
  }

  function Vt(e) {
    return _.uploadContacts(Dt.uploadContacts, e);
  }

  var Yt = {
    people: [],
    peopleCount: 0,
    createdId: "",
    peopleFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    },
    companies: [],
    companyCount: 0,
    companyFilters: {
      offset: 0,
      itemsPerPage: 50,
      name: ""
    },
    person: {
      isLoading: !1,
      results: null,
      selected: null
    }
  };
  var Kt = {
    searchEmployee: "SEARCH_EMPLOYEEE",
    searchContact: "SEARCH_CONTACT"
  },
      Wt = {
    employees: {
      results: []
    },
    contacts: {
      results: []
    }
  };

  function zt(e, t) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        var n;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e && e.length >= 2 ? (n = [{
                  $populate: "contacts"
                }, {
                  $populate: "companyId"
                }, {
                  type: "Client"
                }, {
                  type: "Industry Contact"
                }, {
                  "$sort[initials]": -1
                }, {
                  $limit: 100
                }], e && n.push({
                  $search: "name|department|location|initials|title|:".concat(e || "")
                }), r(_.search(Kt.searchContact, n))) : r({
                  type: Kt.searchContact,
                  body: {
                    data: []
                  },
                  isLoading: !1
                });

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Xt(e, t, r) {
    return function () {
      var n = y(l.a.mark(function n(o) {
        var a;
        return l.a.wrap(function (n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (!(t || e && e.length >= 2)) {
                  n.next = 7;
                  break;
                }

                return a = [{
                  $populate: "contacts"
                }, {
                  $populate: "managers"
                }, {
                  $populate: "assistants"
                }, {
                  $populate: "assistants.contacts"
                }, {
                  $populate: "managers.contacts"
                }, {
                  $populate: "companyId"
                }, {
                  type: "Employee"
                }, {
                  "$sort[name]": 1
                }, {
                  $limit: 50
                }, {
                  $skip: 50 * r
                }], t && t.split(",").map(function (e) {
                  var t = e.split("-");
                  "title" !== t[0] ? a.push({
                    $filter: "location:".concat(t[1])
                  }) : a.push({
                    $filter: "title:".concat(t[1])
                  });
                }), e && a.push({
                  $filter: "name|department|location|initials|title|:".concat(e || "")
                }), n.abrupt("return", o(_.search(Kt.searchEmployee, a)));

              case 7:
                return n.abrupt("return", o({
                  type: Kt.searchEmployee,
                  body: {
                    data: []
                  },
                  isLoading: !1
                }));

              case 8:
              case "end":
                return n.stop();
            }
          }
        }, n, this);
      }));
      return function (e) {
        return n.apply(this, arguments);
      };
    }();
  }

  var Qt = {
    addRole: "PROJECT_ADD_ROLE",
    addScript: "PROJECT_ADD_SCRIPT",
    addSubmission: "PROJECT_ADD_SUBMISSION",
    createProject: "PROJECT_CREATE_PROJECT",
    loadProject: "PROJECT_LOAD_PROJECT",
    loadProjects: "PROJECT_LOAD_PROJECTS",
    loadRole: "PROJECT_LOAD_ROLE",
    loadScript: "PROJECT_LOAD_SCRIPT",
    loadSubmissions: "PROJECT_LOAD_SUBMISSIONS",
    removeRole: "PROJECT_REMOVE_ROLE",
    removeScript: "PROJECT_REMOVE_SCRIPT",
    removeSubmission: "PROJECT_REMOVE_SUBMISSION",
    searchCompany: "SEARCH_COMPANY",
    searchPerson: "SEARCH_PERSON",
    searchProject: "SEARCH_PROJECT",
    setProjects: "PROJECT_SET_PROJECTS",
    setRoleForm: "PROJECT_SET_ROLE_FORM",
    setScriptForm: "PROJECT_SET_SCRIPT_FORM",
    setSubmissionForm: "PROJECT_SET_SUBMISSION_FORM",
    updateForm: "PROJECT_UPDATE_FORM",
    updateProject: "PROJECT_UPDATE_PROJECT",
    updateRole: "PROJECT_UPDATE_ROLE",
    updateRoleForm: "PROJECT_UPDATE_ROLE_FORM",
    updateScript: "PROJECT_UPDATE_SCRIPT",
    updateScriptForm: "PROJECT_UPDATE_SCRIPT_FORM",
    updateSubmission: "PROJECT_UPDATE_SUBMISSION",
    updateSubmissionForm: "PROJECT_UPDATE_SUBMISSION_FORM"
  };

  function Zt(e, t) {
    var r = "name:".concat(e, "&");
    t && (r += "type=" + t);
    var n = [{
      $filter: r
    }];
    return m(Qt.searchPerson, "/person", "GET", null, n);
  }

  function er(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return m(Qt.searchProject, "/project", "GET", null, t);
  }

  function tr(e) {
    var t = [{
      $search: "name:".concat(e)
    }];
    return m(Qt.searchCompany, "/company", "GET", null, t);
  }

  function rr(e) {
    return j.get(Qt.loadProject, e, [{
      $populate: "literaryAgents"
    }, {
      $populate: "networks"
    }, {
      $populate: "productionCompany"
    }, {
      $populate: "productionCompanies"
    }, {
      $populate: "studios"
    }, {
      $populate: "talentAgents"
    }, {
      $populate: "agents"
    }, {
      $populate: "castings"
    }, {
      $populate: "castings.personId"
    }, {
      $populate: "trackings"
    }, {
      $populate: "trackings.personId"
    }]);
  }

  function nr(e) {
    return j.list(Qt.loadProjects, e);
  }

  function or(e) {
    return m(Qt.loadRole, "/project_role", "GET", null, [{
      projectId: e
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }, {
      "$sort[type]": 1
    }]);
  }

  function ar(e) {
    return m(Qt.loadScript, "/project_script", "GET", null, [{
      projectId: e
    }, {
      $populate: "contactId"
    }, {
      $populate: "projectId"
    }]);
  }

  function cr(e) {
    return m(Qt.loadSubmissions, "/project_submission", "GET", null, [{
      projectId: e
    }, {
      $populate: "castingId"
    }, {
      $populate: "personId"
    }, {
      $populate: "projectId"
    }]);
  }

  function sr(e, t) {
    return function (r, n) {
      r({
        type: Qt.updateRoleForm,
        field: e,
        value: t
      });
    };
  }

  function ur(e, t) {
    return function (r, n) {
      r({
        type: Qt.updateSubmissionForm,
        field: e,
        value: t
      });
    };
  }

  function ir(e, t) {
    return function (r, n) {
      r({
        type: Qt.updateScriptForm,
        field: e,
        value: t
      });
    };
  }

  function dr(e) {
    return {
      type: Qt.setSubmissionForm,
      projectSubmissionForm: {
        _id: e._id,
        status: e.status,
        person: e.personId,
        casting: e.castingId,
        castingId: e.castingId ? e.castingId._id : "",
        castingName: e.castingId ? e.castingId.name : "",
        note: e.note
      }
    };
  }

  function pr(e) {
    return {
      type: Qt.setRoleForm,
      projectRoleForm: {
        _id: e._id,
        status: e.status,
        person: e.personId,
        notes: e.notes,
        type: e.type,
        isClient: e.isClient
      }
    };
  }

  function lr(e) {
    return {
      type: Qt.setScriptForm,
      projectScriptForm: {
        _id: e._id,
        type: e.type,
        url: e.url,
        contact: e.contactId,
        version: e.version,
        title: e.title,
        format: e.format
      }
    };
  }

  function fr(e, t) {
    return function (r, n) {
      r({
        type: Qt.updateForm,
        field: e,
        value: t
      });
    };
  }

  function yr(e, t) {
    return j.update(Qt.updateProject, e, t);
  }

  function mr(e, t) {
    return A.update(Qt.updateRole, e, t);
  }

  function hr(e, t) {
    return F.update(Qt.updateSubmission, e, t);
  }

  function Cr(e, t) {
    return w.update(Qt.updateScript, e, t);
  }

  function Pr(e, t) {
    return function (r, n) {
      n().projects.castings;
      r(L.update(Qt.updateCasting, e, t));
    };
  }

  function _r(e) {
    return L.delete(Qt.removeCasting, e);
  }

  function Tr(e) {
    return F.delete(Qt.removeSubmission, e);
  }

  function Er(e) {
    return w.delete(Qt.removeScript, e);
  }

  function vr(e) {
    return A.delete(Qt.removeCasting, e);
  }

  function gr(e) {
    return j.create(Qt.createProject, e, []);
  }

  var Or = {
    project: null,
    castings: [],
    roles: [],
    trackings: [],
    scripts: [],
    submissions: [],
    projects: [],
    projectCount: 0,
    projectFilters: {
      offset: 0,
      limit: 50
    },
    isLoading: !1,
    projectRoleForm: {
      type: "",
      status: "",
      notes: "",
      isClient: "no",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    },
    projectScriptForm: {
      contact: {
        isLoading: !1,
        results: null,
        selected: null
      },
      url: "",
      title: "",
      type: "",
      format: "",
      version: ""
    },
    projectSubmissionForm: {
      casting: {
        isLoading: !1,
        results: null,
        selected: null
      },
      status: "",
      notes: "",
      person: {
        isLoading: !1,
        results: null,
        selected: null
      }
    },
    projectForm: {
      medium: "",
      name: "",
      status: "",
      type: ""
    }
  };
  var Rr = Object(n.combineReducers)({
    user: function user() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : W,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case x.login:
          return i({}, e);

        case x.status:
        case x.editStatus:
          return i({}, e, {
            isLoading: t.isLoading,
            status: t.body ? D.orderBy(t.body.data, ["order"], ["asc"]) : []
          });

        case x.moveStatus:
          return i({}, e, {
            status: Object($.arrayMove)(e.status, t.oldIndex, t.newIndex)
          });

        case x.updateStatus:
          return i({}, e, {
            status: e.status.map(function (e, r) {
              return r === t.index ? (e[t.field] = t.value, e) : e;
            })
          });

        case x.updateDeskSettings:
          var r = t.body ? t.body : e.desk;
          return e.user.deskIds.filter(function (e) {
            return e._id === r._id;
          })[0].settings = r.settings, i({}, e, {
            desk: r
          });

        case x.invalidate:
          return {
            user: null
          };

        case x.loadUser:
          return i({}, e, {
            isLoading: t.isLoading,
            user: t.body ? i({}, e.user, t.body) : e.user
          });

        case x.setDesk:
          return i({}, e, {
            desk: t.desk
          });

        case x.setAuth:
          return i({}, e, {
            user: i({}, e.user, {
              auth: t.auth
            })
          });

        default:
          return e;
      }
    },
    callForm: function callForm() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ce,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ae.updateForm:
          var r;
          return i({}, e, (u(r = {}, t.field, t.value), u(r, "edited", "notes" !== t.field || e.edited), r));

        case ae.clearPerson:
          return i({}, e, {
            person: ce.person,
            outlook: ce.outlook,
            contact: ce.contact,
            type: ce.type,
            info: ce.info
          });

        case ae.clearPersonSearch:
          return i({}, e, {
            person: i({}, e.person, {
              results: null
            }),
            outlook: ce.outlook
          });

        case ae.clearContactSearch:
          return i({}, e, {
            contact: i({}, e.contact, {
              results: null
            })
          });

        case ae.resetForm:
          return i({}, ce, {
            showForm: e.showForm,
            date: new Date()
          });

        case ae.searchResults:
          return i({}, e, {
            person: i({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.data ? t.data : []
            })
          });

        case ae.searchOutlook:
          return i({}, e, {
            outlook: {
              isLoading: t.isLoading,
              results: t.body && t.body.map(function (e) {
                return {
                  name: e.displayName,
                  companyName: e.companyName,
                  contacts: function (e) {
                    var t = [];
                    return e.emailAddresses.length > 0 && t.push({
                      contactType: "Email",
                      contact: e.emailAddresses[0].address
                    }), e.businessPhones.length > 0 && t.unshift({
                      contactType: "Office Phone",
                      contact: e.businessPhones[0]
                    }), e.homePhones.length > 0 && t.unshift({
                      contactType: "Home Phone",
                      contact: e.homePhones[0]
                    }), e.mobilePhone && t.unshift({
                      contactType: "Mobile Phone",
                      contact: e.mobilePhone
                    }), e.imAddresses.length > 0 && t.push({
                      contactType: "Message",
                      contact: e.imAddresses[0]
                    }), t;
                  }(e),
                  addresses: function (e) {
                    var t = [];
                    return ["homeAddress", "otherAddress", "businessAddress"].map(function (r) {
                      var n = "";

                      switch (r) {
                        case "homeAddress":
                          n = "Home";
                          break;

                        case "businessAddress":
                          n = "Work";
                          break;

                        default:
                          n = "Unknown";
                      }

                      e[r] && e[r].street && t.push({
                        address: e[r].street,
                        state: e[r].state,
                        city: e[r].city,
                        country: e[r].countryOrRegion,
                        zip: e[r].postalCode,
                        type: n
                      });
                    }), t;
                  }(e),
                  outlook: !0
                };
              })
            }
          });

        case ae.searchPrivate:
          return i({}, e, {
            person: i({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? e.person.results ? e.person.results.concat(t.body) : t.body : e.person.results
            })
          });

        case ae.selectPerson:
          var n = t.person || t.body;
          return n ? i({}, e, {
            name: n.name,
            person: i({}, e.person, {
              selected: n,
              results: null
            }),
            outlook: i({}, e.outlook, {
              results: null
            }),
            contact: {
              results: n.contacts
            }
          }) : e;

        case ae.selectType:
          return i({}, e, {
            type: t.contactType
          });

        case ae.showForm:
          return i({}, e, {
            showForm: !e.showForm
          });

        case ae.searchContact:
          return i({}, e, {
            contact: {
              results: t.results,
              selected: null
            }
          });

        case ae.selectContact:
          return t.contact ? i({}, e, {
            contact: i({}, e.contact, {
              selected: t.contact,
              results: null
            }),
            type: t.contact.contactType,
            info: t.contact.contact
          }) : i({}, e, {
            contact: i({}, e.contact, {
              selected: null
            })
          });

        case ae.editCallTodo:
          return i({}, e, {
            editCallTodo: t.callTodo
          });

        default:
          return e;
      }
    },
    callTodo: function callTodo() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Fe,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Re.list:
          return t.isLoading ? i({}, e, {
            calls: i({}, e.calls, {
              isLoading: t.isLoading
            })
          }) : i({}, e, {
            calls: {
              callTodos: t.body ? t.body.data : [],
              total: t.body && t.body.total,
              limit: t.body && t.body.limit,
              skip: t.body && t.body.skip,
              isLoading: t.isLoading
            }
          });

        case Re.preview:
          return i({}, e, {
            preview: i({}, e.preview, {
              call: t.call,
              person: t.call ? t.call.recipientId : null
            })
          });

        case Re.loadHistory:
          return i({}, e, {
            preview: i({}, e.preview, {
              history: t.body ? t.body.data : e.preview.history
            })
          });

        case Re.loadPerson:
          return i({}, e, {
            preview: i({}, e.preview, {
              person: t.body ? t.body : e.preview.person,
              isLoading: t.isLoading
            })
          });

        default:
          return e;
      }
    },
    filters: function filters() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Je,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Ne.loadFilters:
          return i({}, e, {
            filters: t.body && t.body.data ? t.body.data.map(function (e) {
              return e.values ? e : i({}, e, {
                values: JSON.parse(e.values)
              });
            }) : e.filters
          });

        case Ne.createFilter:
          return i({}, e);

        case Ne.updateFilter:
          return t.body ? i({}, e, {
            filters: e.filters.map(function (e) {
              return e._id !== t.body._id ? e : i({}, t.body);
            })
          }) : e;

        case Ne.setCurrentFilter:
          return i({}, e, {
            currentFilterIndex: e.filters.findIndex(function (e) {
              return e._id === t.newFilterId;
            })
          });

        default:
          return e;
      }
    },
    projectCastings: function projectCastings() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : We,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Ue.loadProjectCasting:
          return i({}, e, {
            isLoading: t.isLoading,
            projectCasting: t.body ? t.body : e.projectCasting
          });

        case Ue.loadProjectCastings:
          return i({}, e, {
            projectCastings: t.body ? t.body.data : e.projectCastings
          });

        case Ue.setProjectCastingForm:
          return i({}, e, {
            projectCastingForm: t.projectCastingForm
          });

        case Ue.updateProjectCasting:
          return t.isLoading ? i({}, e, {
            projectCasting: i({}, e.projectCasting, t.payload),
            isLoading: !0
          }) : i({}, e, {
            isLoading: t.isLoading,
            projectCasting: t.body ? t.body : e.projectCasting
          });

        case Ue.updateProjectCastingForm:
          return i({}, e, {
            projectCastingForm: i({}, e.projectCastingForm, u({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    projectNotes: function projectNotes() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ot,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case ze.loadProjectNote:
          return i({}, e, {
            isLoading: t.isLoading,
            projectNote: t.body ? t.body : e.projectNote
          });

        case ze.loadProjectNotes:
          return i({}, e, {
            projectNotes: t.body ? t.body.data : e.projectNotes
          });

        case ze.setProjectNoteForm:
          return i({}, e, {
            projectNoteForm: t.projectNoteForm
          });

        case ze.updateProjectNote:
          return t.isLoading ? i({}, e, {
            projectNote: i({}, e.projectNote, t.payload),
            isLoading: !0
          }) : i({}, e, {
            isLoading: t.isLoading,
            projectNote: t.body ? t.body : e.projectNote
          });

        case ze.updateProjectNoteForm:
          return i({}, e, {
            projectNoteForm: i({}, e.projectNoteForm, u({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    projectTrackings: function projectTrackings() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pt,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case at.setProjectTrackingForm:
          return i({}, e, {
            projectTrackingForm: t.projectTrackingForm
          });

        case at.updateProjectTracking:
          return t.isLoading ? i({}, e, {
            projectTracking: i({}, e.projectTracking, t.payload),
            isLoading: !0
          }) : i({}, e, {
            isLoading: t.isLoading,
            projectTracking: t.body ? t.body : e.projectTracking
          });

        case at.updateProjectTrackingForm:
          return i({}, e, {
            projectTrackingForm: i({}, e.projectTrackingForm, u({}, t.field, t.value))
          });

        default:
          return e;
      }
    },
    profile: function profile() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Nt,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case mt.loadPerson:
          return i({}, e, {
            isLoading: t.isLoading,
            person: t.body ? t.body : e.person,
            relationships: [],
            calls: [],
            history: []
          });

        case mt.updatePerson:
          return t.isLoading ? i({}, e, {
            person: i({}, e.person, t.payload),
            isLoading: !0
          }) : i({}, e, {
            isLoading: t.isLoading,
            person: t.body ? t.body : e.person
          });

        case mt.listHistory:
          return i({}, e, {
            history: t.body ? t.body.data : e.history
          });

        case mt.listCalls:
          return i({}, e, {
            calls: t.body ? t.body.data : e.calls
          });

        case mt.loadRelation:
          return i({}, e, {
            relationships: t.relationships
          });

        default:
          return e;
      }

      return e;
    },
    dashboard: function dashboard() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Yt,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Dt.listPeople:
          return i({}, e, {
            people: t.body ? t.body.data : e.people,
            peopleCount: t.body ? t.body.total : e.peopleCount,
            peopleFilters: e.peopleFilters
          });

        case Dt.listCompany:
          return i({}, e, {
            companies: t.body ? t.body.data : e.companies,
            companyCount: t.body ? t.body.total : e.companyCount,
            companyFilters: e.companyFilters
          });

        case Dt.deletePeople:
          return kt.notify.show("Deleted Person", "success"), i({}, e, {
            people: t.body ? e.people.filter(function (e) {
              return e._id !== t.body._id;
            }) : e.people,
            peopleCount: e.peopleCount - 1
          });

        case Dt.editCompany:
          return kt.notify.show("Edited Company", "success"), i({}, e, {
            companies: t.body ? e.companies.map(function (e) {
              e._id !== t.body._id && (e = t.body);
            }) : e.companies
          });

        case Dt.deleteCompany:
          return kt.notify.show("Deleted Company", "success"), i({}, e, {
            companies: t.body ? e.companies.filter(function (e) {
              return e._id !== t.body._id;
            }) : e.companies,
            companyCount: e.companyCount - 1
          });

        case Dt.createCompany:
          return kt.notify.show("Created Company", "success"), i({}, e, {
            companies: t.body ? e.companies.concat(t.body) : e.companies,
            companyCount: e.companyCount + 1
          });

        case Dt.createPerson:
          return kt.notify.show("Created Person", "success"), i({}, e, {
            people: t.body ? e.people.concat(t.body) : e.people,
            peopleCount: e.peopleCount + 1,
            createdId: t.body ? t.body._id : ""
          });

        case Dt.mergePerson:
          return kt.notify.show("Merged People", "success"), i({}, e, {
            createdId: t.body ? t.body._id : ""
          });

        case Dt.uploadContacts:
          return i({}, e, {
            data: t.body && t.body.data ? t.body : {}
          });

        case Dt.searchPerson:
          return i({}, e, {
            person: i({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.data : []
            })
          });

        default:
          return e;
      }
    },
    portal: function portal() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Wt,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Kt.searchEmployee:
          return i({}, e, {
            employees: i({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.offset > 0 ? D.orderBy(e.employees.results.concat(t.body.data), [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["desc", "desc"]) : D.orderBy(t.body.data, [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["desc", "desc"]) : D.orderBy(e.employees.results, [function (e) {
                return e.name.split(" ")[1];
              }, function (e) {
                return e.name.split(" ")[0];
              }], ["desc", "desc"])
            })
          });

        case Kt.searchContact:
          return i({}, e, {
            contacts: i({}, e.person, {
              selected: null,
              isLoading: t.isLoading,
              results: t.body ? t.body.data : []
            })
          });

        default:
          return e;
      }
    },
    projects: function projects() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Or,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case Qt.setProjects:
          return i({}, e, {
            projects: t.projects ? t.projects : e.projects
          });

        case Qt.loadProjects:
          return i({}, e, {
            isLoading: t.isLoading,
            projects: t.body ? t.body.data : e.projects,
            projectCount: t.body ? t.body.total : e.projectCount,
            projectPagination: e.projectFilters
          });

        case Qt.searchProject:
          return i({}, e, {
            isLoading: t.isLoading,
            projects: t.body ? t.body.data : e.projects
          });

        case Qt.loadProject:
          return t.body && t.body.castings.sort(function (e, t) {
            return e.priority - t.priority;
          }), t.body && t.body.trackings.sort(function (e, t) {
            return t.updated - e.updated;
          }), i({}, e, {
            isLoading: t.isLoading,
            project: t.body ? t.body : e.project
          });

        case Qt.updateProject:
          return t.isLoading ? i({}, e, {
            project: i({}, e.project, t.payload),
            isLoading: !0
          }) : i({}, e, {
            isLoading: t.isLoading,
            project: t.body ? t.body : e.project
          });

        case Qt.loadCastings:
          return i({}, e, {
            castings: t.body ? t.body.data : e.castings
          });

        case Qt.loadRole:
          return i({}, e, {
            roles: t.body ? t.body.data : e.roles
          });

        case Qt.loadSubmissions:
          return i({}, e, {
            submissions: t.body ? t.body.data : e.submissions
          });

        case Qt.loadScript:
          return i({}, e, {
            scripts: t.body ? t.body.data : e.scripts
          });

        case Qt.updateRoleForm:
          return i({}, e, {
            projectRoleForm: i({}, e.projectRoleForm, u({}, t.field, t.value))
          });

        case Qt.updateSubmissionForm:
          return i({}, e, {
            projectSubmissionForm: i({}, e.projectSubmissionForm, u({}, t.field, t.value))
          });

        case Qt.updateScriptForm:
          return i({}, e, {
            projectScriptForm: i({}, e.projectScriptForm, u({}, t.field, t.value))
          });

        case Qt.updateForm:
          return i({}, e, {
            projectForm: i({}, e.projectForm, u({}, t.field, t.value))
          });

        case Qt.setRoleForm:
          return i({}, e, {
            projectRoleForm: t.projectRoleForm
          });

        case Qt.setSubmissionForm:
          return i({}, e, {
            projectSubmissionForm: t.projectSubmissionForm
          });

        case Qt.setScriptForm:
          return i({}, e, {
            projectScriptForm: t.projectScriptForm
          });

        default:
          return e;
      }
    },
    archive: function archive() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : te,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case z.listArchive:
          return i({}, e, {
            archives: t.body ? t.body.data : e.archives,
            archiveCount: t.body ? t.body.total : e.archiveCount
          });

        case z.clearArchive:
          return i({}, e, {
            archives: [],
            archiveCount: 0
          });

        case z.searchArchive:
          return i({}, e, {
            archives: t.body ? t.body.data : e.archives,
            isLoading: t.isLoading,
            archiveCount: t.body ? t.body.total : e.archiveCount
          });

        default:
          return e;
      }
    },
    deployOptions: function deployOptions() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : re;
      return arguments.length > 1 && arguments[1], e;
    }
  }),
      Sr = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || n.compose)(Object(n.applyMiddleware)(a.a, s.a));

  function jr(e) {
    var t = new URLSearchParams(window.location.search);
    t.has("token") && localStorage.setItem("uta.auth", t.get("token"));
    var r = {
      user: {
        user: {
          auth: localStorage["uta.auth"]
        }
      },
      deployOptions: e
    };
    return Object(n.createStore)(Rr, r, Sr);
  }

  var br = {
    set: "SET_CURRENT_NOTES"
  };

  function Ar(e) {
    return function (t) {
      t({
        type: br.set,
        notes: e
      });
    };
  }

  var Ir = {
    searchLogs: "SEARCH_LOGS",
    searchPersons: "SEARCH_PERSONS"
  };

  function Lr(e) {
    return function () {
      var t = y(l.a.mark(function t(r) {
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r(Fr(e));

              case 2:
                return t.sent, t.next = 5, r(wr(e));

              case 5:
                t.sent;

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }

  function Fr(e) {
    return R.list(Ir.searchLogs, [{
      $populate: "recipientId"
    }, {
      $populate: "contactId"
    }, {
      $limit: 10
    }, {
      "$sort[occurrence_date]": -1
    }, {
      $search: "contactInfo|notes"
    }]);
  }

  function wr(e) {
    return function (e) {
      e(_.search(Ir.searchPerson, [{
        $populate: "contacts"
      }, {
        $populate: "companyId"
      }, {
        "type[$ne]": "Industry Contact"
      }]));
    };
  }

  function Nr(e, t, r, n, o, a) {
    return kr.apply(this, arguments);
  }

  function kr() {
    return (kr = y(l.a.mark(function e(t, r, n, o, a, c) {
      var s,
          u,
          i,
          d,
          p,
          f,
          y,
          m,
          h = arguments;
      return l.a.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return s = h.length > 6 && void 0 !== h[6] ? h[6] : "application/json", u = "GET" !== o, i = c && c.map(function (e) {
                return "".concat(Object.keys(e)[0], "=").concat(Object.values(e)[0]);
              }).join("&"), d = c ? n + "?" + i : n, p = "".concat(r).concat(d), f = u ? JSON.stringify(a) : void 0, y = {
                Authorization: "JWT " + t.auth,
                Accept: s,
                "Content-Type": s
              }, e.next = 9, window.fetch(p, {
                method: o,
                body: f,
                headers: new Headers(y),
                mode: "cors",
                cache: "default",
                redirect: "follow"
              });

            case 9:
              if (m = e.sent, "application/pdf" !== s && "text/csv" !== s) {
                e.next = 14;
                break;
              }

              return e.abrupt("return", m);

            case 14:
              return e.abrupt("return", m.json());

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }))).apply(this, arguments);
  }

  r.d(t, "createStoreWithOptions", function () {
    return jr;
  }), r.d(t, "searchArchive", function () {
    return X;
  }), r.d(t, "listArchive", function () {
    return Q;
  }), r.d(t, "updateArchive", function () {
    return Z;
  }), r.d(t, "clearArchive", function () {
    return ee;
  }), r.d(t, "updateForm", function () {
    return se;
  }), r.d(t, "showForm", function () {
    return ue;
  }), r.d(t, "clearPerson", function () {
    return ie;
  }), r.d(t, "clearPersonSearch", function () {
    return de;
  }), r.d(t, "clearContactSearch", function () {
    return pe;
  }), r.d(t, "resetForm", function () {
    return le;
  }), r.d(t, "searchPerson", function () {
    return fe;
  }), r.d(t, "searchContact", function () {
    return ye;
  }), r.d(t, "selectPerson", function () {
    return me;
  }), r.d(t, "selectType", function () {
    return he;
  }), r.d(t, "selectContact", function () {
    return Ce;
  }), r.d(t, "editCall", function () {
    return Pe;
  }), r.d(t, "createPerson", function () {
    return _e;
  }), r.d(t, "createCompany", function () {
    return Te;
  }), r.d(t, "updatePerson", function () {
    return Ee;
  }), r.d(t, "createAddress", function () {
    return ve;
  }), r.d(t, "createContact", function () {
    return ge;
  }), r.d(t, "listHistory", function () {
    return Se;
  }), r.d(t, "listCalls", function () {
    return je;
  }), r.d(t, "createCall", function () {
    return be;
  }), r.d(t, "updateCall", function () {
    return Ae;
  }), r.d(t, "deleteCall", function () {
    return Ie;
  }), r.d(t, "previewCall", function () {
    return Le;
  }), r.d(t, "searchPersonDashboard", function () {
    return $t;
  }), r.d(t, "listPeople", function () {
    return xt;
  }), r.d(t, "listCompany", function () {
    return Jt;
  }), r.d(t, "saveCompany", function () {
    return Mt;
  }), r.d(t, "mergePerson", function () {
    return Ut;
  }), r.d(t, "savePerson", function () {
    return Ht;
  }), r.d(t, "editCompany", function () {
    return Gt;
  }), r.d(t, "deletePerson", function () {
    return qt;
  }), r.d(t, "deleteCompany", function () {
    return Bt;
  }), r.d(t, "uploadContacts", function () {
    return Vt;
  }), r.d(t, "loadFilters", function () {
    return ke;
  }), r.d(t, "createFilter", function () {
    return De;
  }), r.d(t, "updateFilter", function () {
    return $e;
  }), r.d(t, "setCurrentFilter", function () {
    return xe;
  }), r.d(t, "setNotes", function () {
    return Ar;
  }), r.d(t, "searchEmployee", function () {
    return Xt;
  }), r.d(t, "searchContactPortal", function () {
    return zt;
  }), r.d(t, "searchPersonProfile", function () {
    return ht;
  }), r.d(t, "searchCompany", function () {
    return Ct;
  }), r.d(t, "loadPerson", function () {
    return Pt;
  }), r.d(t, "updatePersonProfile", function () {
    return _t;
  }), r.d(t, "updateContact", function () {
    return Tt;
  }), r.d(t, "updateAddress", function () {
    return Et;
  }), r.d(t, "updateRelation", function () {
    return vt;
  }), r.d(t, "addContact", function () {
    return gt;
  }), r.d(t, "addAddress", function () {
    return Ot;
  }), r.d(t, "addRelation", function () {
    return Rt;
  }), r.d(t, "removeContact", function () {
    return St;
  }), r.d(t, "removeAddress", function () {
    return jt;
  }), r.d(t, "removeRelation", function () {
    return bt;
  }), r.d(t, "listHistoryProfile", function () {
    return At;
  }), r.d(t, "listCallsProfile", function () {
    return It;
  }), r.d(t, "loadRelation", function () {
    return Lt;
  }), r.d(t, "listByPerson1", function () {
    return Ft;
  }), r.d(t, "listByPerson2", function () {
    return wt;
  }), r.d(t, "loadProjectCastings", function () {
    return He;
  }), r.d(t, "loadProjectCasting", function () {
    return Ge;
  }), r.d(t, "createProjectCasting", function () {
    return qe;
  }), r.d(t, "removeProjectCasting", function () {
    return Be;
  }), r.d(t, "updateProjectCasting", function () {
    return Ve;
  }), r.d(t, "updateProjectCastingForm", function () {
    return Ye;
  }), r.d(t, "setProjectCastingForm", function () {
    return Ke;
  }), r.d(t, "loadProjectNotes", function () {
    return Xe;
  }), r.d(t, "loadProjectNote", function () {
    return Qe;
  }), r.d(t, "createProjectNote", function () {
    return Ze;
  }), r.d(t, "removeProjectNote", function () {
    return et;
  }), r.d(t, "updateProjectNote", function () {
    return tt;
  }), r.d(t, "updateProjectNoteForm", function () {
    return rt;
  }), r.d(t, "setProjectNoteForm", function () {
    return nt;
  }), r.d(t, "createProjectTracking", function () {
    return ct;
  }), r.d(t, "removeProjectTracking", function () {
    return st;
  }), r.d(t, "updateProjectTracking", function () {
    return ut;
  }), r.d(t, "updateProjectTrackingForm", function () {
    return it;
  }), r.d(t, "setProjectTrackingForm", function () {
    return dt;
  }), r.d(t, "searchPersonProject", function () {
    return Zt;
  }), r.d(t, "searchProjects", function () {
    return er;
  }), r.d(t, "searchCompanyProject", function () {
    return tr;
  }), r.d(t, "loadProject", function () {
    return rr;
  }), r.d(t, "loadProjects", function () {
    return nr;
  }), r.d(t, "loadRoles", function () {
    return or;
  }), r.d(t, "loadScripts", function () {
    return ar;
  }), r.d(t, "loadSubmissions", function () {
    return cr;
  }), r.d(t, "updateRoleForm", function () {
    return sr;
  }), r.d(t, "updateSubmissionForm", function () {
    return ur;
  }), r.d(t, "updateScriptForm", function () {
    return ir;
  }), r.d(t, "setSubmissionForm", function () {
    return dr;
  }), r.d(t, "setRoleForm", function () {
    return pr;
  }), r.d(t, "setScriptForm", function () {
    return lr;
  }), r.d(t, "updateProjectForm", function () {
    return fr;
  }), r.d(t, "updateProject", function () {
    return yr;
  }), r.d(t, "updateRole", function () {
    return mr;
  }), r.d(t, "updateSubmission", function () {
    return hr;
  }), r.d(t, "updateScript", function () {
    return Cr;
  }), r.d(t, "updateCasting", function () {
    return Pr;
  }), r.d(t, "removeCasting", function () {
    return _r;
  }), r.d(t, "removeSubmission", function () {
    return Tr;
  }), r.d(t, "removeScript", function () {
    return Er;
  }), r.d(t, "removeRole", function () {
    return vr;
  }), r.d(t, "createProject", function () {
    return gr;
  }), r.d(t, "search", function () {
    return Lr;
  }), r.d(t, "redirectToAzure", function () {
    return J;
  }), r.d(t, "invalidateLogin", function () {
    return M;
  }), r.d(t, "loadUser", function () {
    return U;
  }), r.d(t, "setDesk", function () {
    return H;
  }), r.d(t, "updateDeskSettings", function () {
    return G;
  }), r.d(t, "updateStatus", function () {
    return q;
  }), r.d(t, "editStatus", function () {
    return B;
  }), r.d(t, "moveStatus", function () {
    return V;
  }), r.d(t, "listStatus", function () {
    return Y;
  }), r.d(t, "setAuth", function () {
    return K;
  }), r.d(t, "requestPromise", function () {
    return Nr;
  });
}]));